module.exports = __webpack_public_path__ + "img/Application_Logo.ec31f3d6.png";